import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { SolstackLayout } from "./components/layout/layout";
import { IS_APP_DOMAIN, IS_LAUNCHPAD_DOMAIN } from "./lib/appBase";
import { PageViews } from "./lib/pageViews";
import "./style/styles.css";

// The tool suite (wallet provider + every tool) is by far the heaviest part
// of the bundle and none of the indexable pages need it — see src/ToolSuite.js.
const ToolSuite = lazy(() => import("./ToolSuite"));
// Docs/blog pull in gray-matter + js-yaml (+ its transitive esprima) and
// marked just to parse markdown — real weight that every page was paying for
// even the tool suite and plain marketing pages that never render either.
// Each section's chunk is named (webpackChunkName) so the build can list its
// stylesheets for the prerendered pages (webpack.config.js SectionCssPlugin).
const DocsApp = lazy(() => import(/* webpackChunkName: "docs" */ "./docs/DocsApp").then((m) => ({ default: m.DocsApp })));
const BlogApp = lazy(() => import(/* webpackChunkName: "blog" */ "./blog/BlogApp").then((m) => ({ default: m.BlogApp })));
const AcademyApp = lazy(() =>
  import(/* webpackChunkName: "academy" */ "./academy/AcademyApp").then((m) => ({ default: m.AcademyApp }))
);
const LaunchPublicApp = lazy(() =>
  import(/* webpackChunkName: "launch" */ "./launch/LaunchPublicApp").then((m) => ({ default: m.LaunchPublicApp }))
);
// Indexable per-tool landing pages (solstack.xyz/tools/<slug>) — same
// reasoning as docs/blog above: no wallet stack, its own lazy chunk.
const ToolsApp = lazy(() => import(/* webpackChunkName: "tools" */ "./tools/ToolsApp").then((m) => ({ default: m.ToolsApp })));

const suiteFallback = (
  <div
    style={{
      minHeight: "100vh",
      display: "grid",
      placeItems: "center",
      fontFamily: "var(--font-body, system-ui)",
      color: "var(--text-muted, #666)",
    }}
  >
    Loading Solstack…
  </div>
);

const lazyRoute = (element) => <Suspense fallback={suiteFallback}>{element}</Suspense>;

const suite = lazyRoute(<ToolSuite />);

const App = () => {
  return (
    <Router>
      <PageViews />
      <Routes>
        <Route path="/docs/*" element={lazyRoute(<DocsApp />)} />
        <Route path="/blog/*" element={lazyRoute(<BlogApp />)} />
        <Route path="/academy/*" element={lazyRoute(<AcademyApp />)} />
        <Route path="/tools/*" element={lazyRoute(<ToolsApp />)} />
        {IS_APP_DOMAIN || IS_LAUNCHPAD_DOMAIN ? (
          <Route path="/*" element={suite} />
        ) : (
          <>
            {/* Public, indexable sale pages — only on the marketing domain.
                app.<domain>'s own "/launch" is the pump.fun Launcher tool,
                inside the suite's own router; this route must not shadow it. */}
            <Route path="/launch/*" element={lazyRoute(<LaunchPublicApp />)} />
            <Route path="/app/*" element={suite} />
            <Route path="/*" element={<SolstackLayout />} />
          </>
        )}
      </Routes>
    </Router>
  );
};
export default App;
